import type { ExtractAtomValue } from 'jotai';
import { atom } from 'jotai';
import { FRAME_DETAILS_STATUS } from '../../../workers/constants/frame-processor-constants';
import type { FrameDetailsState } from '../../../workers/types/video-frame-processor';
import { ACCURATE_FRAME_RENDERING_LOADING } from '../../labelling/constants';
import atomWithDebounce from '../utils/atom-with-debounce';
export const {
  currentValueAtom: currentFrameAtom,
  debouncedValueAtom: debouncedCurrentFrame
} = atomWithDebounce(0);
export const hoveredFrameAtom = atom<number | null>(null);
export const frameDetailsStateAtom = atom<FrameDetailsState>({
  status: FRAME_DETAILS_STATUS.IDLE
});
export const frameTableAtom = atom(get => {
  const s = get(frameDetailsStateAtom);
  return s.status === FRAME_DETAILS_STATUS.SUCCESS ? s.data.frameTable : null;
});
export const accurateFrameCountAtom = atom(get => {
  const s = get(frameDetailsStateAtom);
  return s.status === FRAME_DETAILS_STATUS.SUCCESS ? s.data.accurateFrameCount : null;
});
export type AccurateFrameRenderingState = typeof ACCURATE_FRAME_RENDERING_LOADING | boolean;
export const accurateFrameRenderingAtom = atom<AccurateFrameRenderingState>(ACCURATE_FRAME_RENDERING_LOADING);
export type VideoPlaybackAtomHydrationList = [typeof currentFrameAtom, ExtractAtomValue<typeof currentFrameAtom>] | [typeof hoveredFrameAtom, ExtractAtomValue<typeof hoveredFrameAtom>];